"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Columns item component.
 *
 * This represents an individual list item that should be placed into a column.
 * In terms of HTML, this is the `<li>` element.
 *
 * @class Columns
 * @public
 */
class ColumnItem extends _react.Component {
  /**
   * Render the component.
   *
   * @returns {ReactElement} li
   * @api public
   */
  render() {
    const props = this.props;
    const className = (0, _classnames.default)(props.className, {
      selected: props.isSelected
    });
    return /*#__PURE__*/_react.default.createElement("li", {
      className: className
    }, this.props.children);
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
ColumnItem.propTypes = {
  isSelected: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = ColumnItem;
exports.default = _default;